export default __webpack_public_path__ + "static/media/PTI35.74795f6a.jpg";